export const res = {
  rememberMeLabel: {
    is: 'Muna eftir mér',
    en: 'Remember me',
    pl: 'Zapamiętaj mnie',
  } as const,
  rememberMe: {
    is: 'Þú þarft þá ekki að nota QR-kóða við næstu innskráningu. Aðeins er ráðlegt að láta vafrann muna eftir þér á einkatölvum.',
    en: "This means you won't have to use a QR code the next time you log in. We only recommend letting the browser remember you on a personal computer.",
    pl: 'Następnym razem nie musisz używać kodu QR w procesie logowania. Trzeba tylko wybrać opcję zapamiętania Ciebie w komputerze osobistym.',
  } as const,
  savedUsers: {
    is: 'Sjá þekkta notendur',
    en: 'See known users',
    pl: 'Zobacz znanych użytkowników',
  } as const,
  scanQrCode: {
    is: 'Skannaðu QR-kóðann hér á síðunni með símanum þínum. Þá opnast Landsbankaappið og þú getur notað það til að auðkenna þig með fingrafari eða andlitsgreiningu.',
  } as const,
  loginUsingApp: {
    is: 'Skráðu þig inn í netbankann með Landsbankaappinu.',
    en: "Log in to online banking with Landsbankinn's app.",
    pl: 'Zaloguj się do bankowości elektronicznej za pomocą aplikacji Landsbankaappið.',
  } as const,
};
